<template>
    <div>
            <div class="ibox select-services-dropdown" id="customer_rating_box" v-if="showRates">
                <div class="ibox-content mobile-service-ibox-content p-left-15 p-right-15"  style="border: none">
                    <p class="font-size-18 bold " style="margin-top: 15px">
                        <span class="select-services-dropdown-title"> Customer Rating </span>
                    </p>
                <div class="ibox float-e-margins " v-for="(contractor, contractorIndex) of contractorsData" :key="index" style="margin-top:5px;">
                    <div class="form-horizontal">
                        <div :class="`form-group has_contractor_box_${contractor.contractor_id}`">

                            <div class="col-md-12 contractorBox" :id='`rating_${contractor.contractor_id}`'>
                                <div>

                                    <label style="text-align:left;display: block;font-size: 14px;" :cont_id='contractor.contractor_id'>{{ contractor.display_name}}</label>
    <!--                                 Menu Item-->
                                    <div class="float-right btn-group pair_btn_new_uniq" style="top: -37px;" v-if="loggedUserData.role_id != 1">
                                        <button data-toggle="dropdown" data-too="tooltip" data-placement="bottom"
                                                aria-haspopup="true" aria-expanded="false"
                                                class="btn btn-default dropdown-toggle  create-btn FontSize">
                                            <i class="fa fa-ellipsis-v " style="color:rgba(138, 138, 138,1);font-size: 18px;"></i>
                                        </button>
                                        <ul class="dropdown-menu pair_of_all_li w_und_767" id="pair_of_all_li "  style="right: 0; left: auto;">
                                            <li class="send-email">
                                                <a id="email_booking_customer" href="#" data-toggle="modal" data-target="#popupi"
                                                   @click="sendEmailToCustomer">Request customer rating</a>
                                            </li>
                                            <li class="send-email">
                                                <a class="a_link" @click="resetContractorRate(`${contractor.contractor_id}`)"><i class="fa fa-refresh"></i> Reset rating&nbsp;</a>
                                            </li>
                                        </ul>
                                    </div>
<!--                                End Menu Items-->
                                </div>

                                <!--                                Start Rates-->
                                <div class="rate-ex1-cnt" v-for="( tag , tagIndex ) of ratingTagData[contractor.contractor_id]" >
                                    <div :class="` rate_box_${tagIndex}`" style="display: block;bottom:9px;">
                                        <div class="stars-mobile">
                                            <div rate="1"
                                                 @mouseover="hoverStarsOn(contractor.contractor_id , 1, tag.rate,tagIndex)"
                                                 @mouseout="hoverStarsOut(contractor.contractor_id , 1, tag.rate,tagIndex)"
                                                 @click="saveRate(contractor.contractor_id, 1 , tag.rating_tag_id, tagIndex)"
                                                 :class="{'rate-btn-1 rate-btn': true, ' rate-btn-active': tag.rate >= 1}"></div>
                                            <div rate="2"
                                                 @mouseover="hoverStarsOn(contractor.contractor_id , 2, tag.rate,tagIndex)"
                                                 @mouseout="hoverStarsOut(contractor.contractor_id , 2, tag.rate,tagIndex)"
                                                 @click="saveRate(contractor.contractor_id, 2 , tag.rating_tag_id, tagIndex)"
                                                 :class="{'rate-btn-2 rate-btn': true, ' rate-btn-active': tag.rate >= 2}"></div>
                                            <div rate="3"
                                                 @mouseover="hoverStarsOn(contractor.contractor_id , 3, tag.rate,tagIndex)"
                                                 @mouseout="hoverStarsOut(contractor.contractor_id , 3, tag.rate,tagIndex)"
                                                 @click="saveRate(contractor.contractor_id, 3 , tag.rating_tag_id, tagIndex)"
                                                 :class="{'rate-btn-3 rate-btn': true, ' rate-btn-active': tag.rate >= 3}"></div>
                                            <div rate="4"
                                                 @mouseover="hoverStarsOn(contractor.contractor_id , 4, tag.rate,tagIndex)"
                                                 @mouseout="hoverStarsOut(contractor.contractor_id , 4, tag.rate,tagIndex)"
                                                 @click="saveRate(contractor.contractor_id, 4 , tag.rating_tag_id, tagIndex)"
                                                 :class="{'rate-btn-4 rate-btn': true, ' rate-btn-active': tag.rate >= 4}" ></div>
                                            <div rate="5"
                                                 @mouseover="hoverStarsOn(contractor.contractor_id , 5, tag.rate,tagIndex)"
                                                 @mouseout="hoverStarsOut(contractor.contractor_id , 5, tag.rate,tagIndex)"
                                                 @click="saveRate(contractor.contractor_id, 5 , tag.rating_tag_id, tagIndex)"
                                                 :class="{'rate-btn-5 rate-btn': true, ' rate-btn-active': tag.rate >= 5}"></div>
                                            <div :tag_id="`${tag.rating_tag_id}`" class='rating_tag'>{{ tag.tag_name}}</div>
                                        </div>
                                    </div>
                                    <div style='clear: both'></div>

                                </div>

<!--                            End Rates-->

<!--                            start Description-->
                                <div v-if="ratingInfoData[contractor.contractor_id] && ratingInfoData[contractor.contractor_id]['desc']" class="desc" style="margin-top: 10px;">
                                    <h4>Description</h4>
                                    <p>{{ ratingInfoData[contractor.contractor_id]['desc']}}</p>
                                </div>
<!--                                End Description -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import axios from 'axios';

require("notifyjs-browser/dist/notify");

export default {
    name: 'BookingRates',
    props: {
        loggedUser : '',
        bookingId : 0,
    },
    components: {
    },
    computed: {
    },
    data() {
        return {
            loggedUserData : (this.loggedUser),
            contractorsData : [],
            bookingData : [],
            ratingTagData : [],
            ratingInfoData : [],
            showRates : 0,

        }
    },
    methods: {
        getBookingRates(){
            let url = `/webservice/get-booking-rates/${this.bookingId}`;
            axios.get(url).then(response => {
                if( response && response.data.showRates){
                    this.showRates = response.data.showRates;
                    this.contractorsData = response.data.contractors;
                    this.bookingData = response.data.booking;
                    this.ratingTagData = response.data.ratingTag;
                    this.ratingInfoData = response.data.rating_info_for_each_contractor;
                }
            });
        },
        sendEmailToCustomer(){
            let url = `/get-canned-responses-form/customer/email/booking/${this.bookingData.booking_id}/${this.bookingData.customer_id}/contractor_rate_email`;
            window.popupi('Email Booking to Customer', url);
            window.closeSummaryPopup();
        },
        resetContractorRate(contractor_id){
            let url = `/booking/contractor/deleteRate/${this.bookingData.booking_id}/booking/${contractor_id}`;
            window.confirm_popup({ title: 'Reset Rating',
                message: 'Resetting your customer rating will remove the star rating provided by your customer for this booking and reset the star rating to blank / unrated. Are you sure you want to reset your customer rating for this booking?',
                confirm: 'Confirm',
                cancel: 'Cancel'
            },function (){
                axios.get(url).then(response => {
                        //by Yosor remove all active stars when reseting the star rating instead of reloading the whole page
                        $('#rating_'+contractor_id).find('.rate-btn').removeClass('rate-btn-active');
                        $.notify(result.msg, result.status)
                });

            })
        },
        hoverStarsOn(contractor_id, key, savedStars, tagIndex){
            $('#rating_' + contractor_id).children(' .rate_box_' + key).find('.rate-btn').removeClass('rate-btn-hover');
            for (var i = key; i >= 0; i--) {
                $("#rating_" + contractor_id+" .rate_box_"+ tagIndex +" .rate-btn-" + i).addClass('rate-btn-hover');
            }

        },
        hoverStarsOut(contractor_id, key, savedStars, tagIndex){
            $('#rating_' + contractor_id + ' .rate_box_' + tagIndex + ' .rate-btn').removeClass('rate-btn-hover');
        },
        saveRate(contractor_id, rateNumber , tagId, tagIndex){
            if(this.loggedUserData.role_id != 1){
                let url = `/customer-rating/booking/${this.bookingData.booking_id}`;
                let inputs = new FormData();
                inputs.append("rate" , rateNumber);
                inputs.append("tag_id" , tagId);
                inputs.append("contractor_id" , contractor_id);

                axios.post(url, inputs, {
                    responseType: 'json', // default
                }).then(response => {
                    $("#rating_" + contractor_id+" .rate_box_"+ tagIndex +" .rate-btn").removeClass('rate-btn-active');
                    for (var i = rateNumber; i >= 0; i--) {
                        $("#rating_" + contractor_id+" .rate_box_"+ tagIndex +" .rate-btn-" + i).addClass('rate-btn-active');
                    }
                    $.notify('Customer rating has been saved successfully', 'success')
                });



            }


        }
    },
    mounted() {
        this.getBookingRates();
    },
    watch:{

    }
}

</script>
<style scoped>
    .contractorBox{
        margin-top: 5px;
    }

    .ibox-title{
        border-bottom: 1px solid #f6f6f6;
    }

</style>